/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from 'axios';
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class BranchOfficeRequest extends MainRequest {

    static addBranchOffice(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_ADD, data)
    }

    static listAllBranchOffice(token) {
        return this.getSEC(ServicePath.BRANCH_OFFICE_LIST_ALL)
    }

    static allBranchOffice() {
        return this.getSEC(ServicePath.BRANCH_OFFICE_LIST_ALL)
    }

    static updateBranchOffice(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_UPDATE, data)
    }

    static deleteBranchOffice(data, token) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_DELETE, data)
    }

    static statusBranchOffice(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_STATUS, data)
    }

    static addBranchOfficeHoursList(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_HOURS_ADD_LIST, data)
    }

    static listHoursByBranchOffice(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_HOURS_BY_ID, data)
    }

    static listHoursByBranchOfficeOrder(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_HOURS_BY_ID_ORDER, data)
    }

    static listAllBranchOffice2() {
        return this.getSEC(ServicePath.BRANCH_OFFICE_ALL_2)
    }

    static principalBranchOffice(data) {
        return this.postSEC(ServicePath.BRANCH_OFFICE_PRINCIPAL, data)
    }

}
